import React from "react"
import Donate from "../base-pages/donate"

const DonateEN = () => {
  return <Donate lang="en" />
}

export default DonateEN
